import React from 'react';
import TermsHeader from '../../components/TermsHeader';

const TermsAndConditionsUnidriver = () => {
  return (
    <div id="terms-wrapper">
        <TermsHeader title="UNI Driver" />
        <div className="terms-page">
            <h1>Terms and Conditions</h1>
            <p>Welcome to Uni Driver! These Terms and Conditions govern your use of our mobile application, which allows drivers to accept ride requests on our cab share platform. By accessing or using our app, you agree to comply with these Terms and Conditions. Please read them carefully.</p>

            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using the Uni Driver app, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree with any of the terms stated herein, please do not use our app.</p>

            <h2>2. Driver Eligibility</h2>
            <p>To use our app as a driver, you must meet the following criteria:</p>
            <ul>
                <li>You must possess a valid driver's license and all necessary permits and certifications required by applicable laws and regulations.</li>
                <li>You must be legally eligible to drive and provide transportation services.</li>
                <li>You must be at least 18 years old.</li>
            </ul>
            <p>By accepting these Terms and Conditions, you represent and warrant that you meet the eligibility criteria mentioned above.</p>

            <h2>3. Driver Account</h2>
            <p>To access and utilize our app, you must create a driver account. You are responsible for maintaining the confidentiality of your account information and password. You agree to provide accurate, current, and complete information during the registration process. You must promptly update any changes to your account information to ensure its accuracy. You are solely responsible for all activities that occur under your account. We reserve the right to suspend or terminate your account if any information provided by you is found to be false, inaccurate, or incomplete.</p>

            <h2>4. Driver Responsibilities</h2>
            <p>As a driver on the Uni Driver platform, you agree to:</p>
            <ul>
                <li>Provide transportation services to passengers who request rides through our app.</li>
                <li>Comply with all local laws and regulations related to driving and transportation services, including insurance requirements and vehicle safety standards.</li>
                <li>Maintain professionalism and conduct while using our app and providing services to passengers.</li>
            </ul>

            <h2>5. Passenger Safety and Conduct</h2>
            <p>Passengers using the Uni Driver platform are expected to:</p>
            <ul>
                <li>Treat drivers with respect and courtesy.</li>
                <li>Not engage in any illegal, offensive, or inappropriate behavior during their ride.</li>
                <li>Comply with all applicable laws and regulations regarding their conduct during the ride.</li>
            </ul>
            <p>We reserve the right to suspend or terminate a passenger's account if they engage in any unlawful, offensive, or inappropriate behavior.</p>

            <h2>6. Payments and Fees</h2>
            <p>The Uni Driver platform facilitates payment processing between passengers and drivers for the transportation services provided. The payment amount and any applicable fees will be clearly communicated to both the passenger and the driver before accepting a ride request. The platform may collect payment on behalf of the driver and deduct any applicable fees before transferring the remaining amount to the driver. Drivers are responsible for any taxes or fees applicable to the income they earn through the Uni Driver platform.</p>

            <h2>7. Intellectual Property</h2>
            <p>All intellectual property rights, including copyrights and trademarks, in the Uni Driver app and its associated materials are owned by or licensed to us. You may not claim ownership of any part of the app or its associated materials.</p>

            <h2>8. Disclaimer of Warranties</h2>
            <p>The Uni Driver app is provided "as is" without any warranties or guarantees of any kind. We make no representations or warranties, express or implied, regarding the functionality, reliability, or suitability of the app for any purpose. We shall not be liable for any damages or losses arising out of your use or inability to use the Uni Driver app.</p>

            <h2>9. Indemnification</h2>
            <p>You agree to indemnify and hold us harmless from any claims, damages, or liabilities arising out of your use of the Uni Driver app or any violation of these Terms and Conditions.</p>

            <h2>10. Governing Law and Jurisdiction</h2>
            <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of South Africa. Any disputes arising out of or in connection with these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts of South Africa.</p>

            <h2>11. Modifications to the Terms and Conditions</h2>
            <p>We reserve the right to modify or update these Terms and Conditions at any time without prior notice. It is your responsibility to review these Terms and Conditions periodically for any changes.</p>

            <p>By using the Uni Driver app, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.</p>
        </div>
        <PrivacyPolicy/>
    </div>
  );
};


const PrivacyPolicy = () => {
  return (
    <div className="terms-page">
      <h1>Privacy Policy</h1>

      <h2>1. Introduction</h2>
      <p>
        UniDriver ("the App") is a ride share application that connects drivers with riders to facilitate transportation services. At UniDriver, we are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the UniDriver App as a driver. By using the App, you consent to the practices described in this Privacy Policy.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>2.1. Personal Information</h3>
      <span>
            When you sign up as a driver on UniDriver, we may collect the following personal information:
            <br/>
            <br/>
            Full name
            <br/>
            Email address
            <br/>
            Phone number
            <br/>
            Profile picture
            <br/>
            Driver's license information
            <br/>
            Vehicle information (e.g., make, model, license plate) 
      </span>

      <h3>2.2. Location Information</h3>
      <span>
      UniDriver requires access to your device's location to provide ride services. We collect and store your location data when you use the App, including your current location and route information during rides.
      </span>

      <h3>2.3. Usage Information</h3>
      <span>
            We collect information about your interaction with the App, including:
            <br/>
            <br/>
            Ride history and details, such as pick-up and drop-off times and locations
            <br/>
            Ratings and reviews provided by riders
            <br/>
            App usage metrics, device information, and mobile network information
      </span>

      <h3>2.4. Communication Data</h3>
      <span>
            We may collect information when you communicate with us or riders through the App, including messages, feedback, and support inquiries.
      </span>

      <h2>3. Use of Information</h2>
      <span>
            We use the collected information for the following purposes:
            <br/>
            <br/>
            3.1. Providing and Managing Services
            <br/>
            Facilitating rides and connecting you with riders
            <br/>
            Verifying your identity, driver's license, and vehicle information
            <br/>
            Processing payments for transportation services
            <br/>
            Communicating with riders regarding ride details, updates, and support
            <br/>
            <br/>
            3.2. Safety and Security
            <br/>
            Conducting background checks and verifying driver qualifications
            Monitoring rides for safety purposes and ensuring compliance with our terms of service
            Protecting the rights, safety, and well-being of riders and drivers
            <br/>
            <br/>
            3.3. Driver Support
            <br/>
            Responding to your inquiries, feedback, and support requests
            Assisting with any issues or disputes related to your use of the App
            <br/>
            <br/>
            3.4. Communication
            <br/>
            Sending important updates, notifications, and service-related messages
            Facilitating communication between you and riders during ride bookings
      </span>

      <h2>4. Disclosure of Information</h2>
      <span>
            We may disclose your information in the following circumstances:
            <br/>
            <br/>
            4.1. Rider Information
            <br/>
            We may share your profile information, including name, photo, and ratings, with riders when you accept ride requests. This allows riders to make informed decisions when choosing a driver.
            <br/>
            <br/>
            4.2. Service Providers
            <br/>
            We may share your information with trusted third-party service providers who assist us in operating, managing, and enhancing the App. These service providers are bound by confidentiality agreements and are only authorized to use your information as necessary to provide the contracted services.
            <br/>
            <br/>
            4.3. Legal Requirements
            <br/>
            We may disclose your information if required to do so by law, court order, or governmental authority. We may also disclose your information to protect our rights, safety, or the rights, safety, or property of others.
            <br/>
            <br/>
            4.4. Business Transfers
            <br/>
            In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred or disclosed as part of the transaction. We will notify you of any such change in ownership or control of your personal information.
      </span>

      <h2>5. Data Retention</h2>
      <span>
        We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. We will delete or anonymize your information when it is no longer needed.
      </span>

      <h2>6. Security</h2>
      <span>
        We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, no data transmission over the internet or method of electronic storage can be guaranteed to be 100% secure. Therefore, while we strive to protect your information, we cannot guarantee its absolute security.
      </span>

      <h2>7. Your Rights</h2>
      <span>
        You have certain rights regarding your personal information, including the right to:
        <br/>
        <br/>
        Access, correct, or update your personal information
        <br/>
        Object to the processing of your personal information
        <br/>
        Request the deletion of your personal information
        <br/>
        Opt-out of receiving marketing communications
        <br/>
        Lodge a complaint with the appropriate data protection authority
        <br/>
        <br/>
        To exercise any of these rights or for any privacy-related inquiries, please contact us using the contact information provided at the end of this Privacy Policy.
      </span>

      <h2>8. Children's Privacy</h2>
      <span>
        UniDriver is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children. If you become aware that a child has provided us with their personal information without parental consent, please contact us, and we will take steps to remove the information from our systems.
      </span>

      <h2>9. Changes to this Privacy Policy</h2>
      <span>
        We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the revised version on our website or through other communication channels. We encourage you to review this Privacy Policy periodically for any updates.
      </span>

      <h2>10. Contact Us</h2>
      <span>
        If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at info@pands.app
      </span>
    </div>
  );
}


export default TermsAndConditionsUnidriver;
